import angular from 'angular';

import CommentDirective from './comment/comment.component';
import CommentForm from './comment-form/comment-form.directive';
// import DialogCommentsDirective from './dialog-comments/dialog-comments.directive';
import GhostComment from './ghost-comment/ghost-comment.directive';
import DialogComments from './dialog-comments/dialog-comments.component';

const DEPENDENCIES = [
  CommentDirective,
  DialogComments,
  CommentForm,
  DialogComments,
  GhostComment,
];

export default angular.module('autoboard.commentModule', DEPENDENCIES)
  .name;
